import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/views/Home.vue";
import Admin from "@/views/Admin.vue";
import About from "@/views/About.vue";
import Help from "@/views/Help.vue";
import SignIn from "@/views/SignIn.vue";
import Dashboard from "@/views/Dashboard.vue";
import Stuff from "@/views/Stuff.vue";
import BlogPost from "@/components/BlogPost";
import Contact from "@/views/Contact.vue";

Vue.use(VueRouter);

const routes = [
  {path: "/", component: Home, props: true},
  {path: "/home", component: Home, props: true},
  {path: "/signin", component: SignIn, props: true},
  {path: "/about", component: About, props: true},
  {path: "/help", component: Help, props: true},
  {path: "/contact", component: Contact, props: true},
  {
    path: "/dashboard/:projectId?",
    component: Dashboard,
    props: true
  },
  {
    path: "/admin/:sectionId?/:itemId?",
    component: Admin,
    props: true
  },
  {path: "/stuff", component: Stuff, props: true},
  {path: "/stuff/:slug", component: BlogPost, props: true},
  {path: "/twitter", beforeEnter() {location.href = 'https://twitter.com/getblueteam'} },
  {path: "/linkedin", beforeEnter() {location.href = 'https://linkedin.com/company/getblueteam'} },
  {path: "/github", beforeEnter() {location.href = 'https://github.com'} }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: function(to) {
    if (to.hash) {
      return {
        selector: to.hash
      };
    }
  }
});

export default router;
